import { useEffect, useRef } from 'react';

const DataTableComponent = ({ i18n, config = {} }) => {
    const tableRef = useRef(null);
    const defaultConfig = {
        language: i18n,
        processing: true,
        destroy: true,
        responsive: true,
        searchDelay: 500,
        ordering: true,
        orderMulti: true,
        autoWidth: false,
        lengthMenu: [20, 40, 60, 100],
        searching: false,
        dom: `
            <'table-top-bar'<'table-info'f>>
            <'table-scroll-container'tr>
            <'table-footer table-footer-sticky clearfix'
                <'table-footer-col table-info'i>
                <'table-footer-col table-length-info'l>
                <'table-footer-col table-pagination-bottom'p>
            >
        `,
        drawCallback: function (settings) {
            const table = settings.oInstance.api();
            if (table.data().length) {
                table.columns.adjust();
            }
        },
    };

    useEffect(() => {
        $(tableRef.current).DataTable({
            ...defaultConfig,
            ...config,
        });
    }, []);

    return (
        <div className="DataTableComponent">
            <div className="table-responsive">
                <div className="data-table-wrapper table-border">
                    <table className="table table-hover" ref={tableRef}></table>
                </div>
            </div>
        </div>
    );
};

export default DataTableComponent;
